module.exports = "/_next/static/images/RichCustomerProfiles@2x-6bb309b5d5112d5611b7f322ba7da82f.webp";